module.exports = __webpack_public_path__ + "static/media/pez_a_tex.d570eb08.png";


//////////////////
// WEBPACK FOOTER
// ./src/resource/pez_a/pez_a_tex.png
// module id = 142
// module chunks = 0